import auth from "./auth";
import system from "./system";
import entities from "./entities";
import entity from "modules/entity/actions";

export default {
	entity,
	auth,
	system,
	entities,
};
